"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildIdentityModel = exports.buildTraitModel = void 0;
var util_1 = require("../features/util");
var collections_1 = require("../utils/collections");
var models_1 = require("./models");
var models_2 = require("./traits/models");
function buildTraitModel(traitJSON) {
    return new models_2.TraitModel(traitJSON.trait_key, traitJSON.trait_value);
}
exports.buildTraitModel = buildTraitModel;
function buildIdentityModel(identityJSON) {
    var featureList = identityJSON.identity_features
        ? new (collections_1.IdentityFeaturesList.bind.apply(collections_1.IdentityFeaturesList, __spreadArray([void 0], __read(identityJSON.identity_features.map(function (f) { return (0, util_1.buildFeatureStateModel)(f); })), false)))() : [];
    var model = new models_1.IdentityModel(identityJSON.created_date, identityJSON.identity_traits
        ? identityJSON.identity_traits.map(function (trait) { return buildTraitModel(trait); })
        : [], featureList, identityJSON.environment_api_key, identityJSON.identifier, identityJSON.identity_uuid);
    model.djangoID = identityJSON.django_id;
    return model;
}
exports.buildIdentityModel = buildIdentityModel;
